import React from "react";
import { Column } from "./dataTable.common";
import { BodyField } from "./dataTable.bodyField";

export interface DataRowProps<T> {
  columns: Column<T>[];
  datarow: T;
  classNameSelector?: (item: T) => string;
  styleSelector?: (item: T | null) => React.CSSProperties | undefined;
  onRowClick?: (row: T, ref: HTMLTableRowElement | null) => void;
}

export class DataRow extends React.Component<DataRowProps<any>> {

  private tableRow: HTMLTableRowElement | null;

  private onRowClick = (e: React.SyntheticEvent<HTMLTableRowElement>) => {
    if (this.props.onRowClick) {
      e.preventDefault();
      e.stopPropagation();
      this.props.onRowClick(this.props.datarow, this.tableRow)
    }
  }

  render() {
    return (
      <tr ref={el => this.tableRow = el}
        onClick={this.onRowClick}
        className={
          this.props.classNameSelector &&
          this.props.classNameSelector(this.props.datarow)
        }
        style={
          this.props.styleSelector &&
          this.props.styleSelector(this.props.datarow)
        }
      >
        {this.props.columns.map((column, columnN) => (
          <BodyField
            key={columnN}
            datarow={this.props.datarow}
            column={column}
          />
        ))}
      </tr>
    );
  }
}
